<!-- <form [formGroup]="srdContentForm"> -->
<a
    *ngIf="sharedContent == null"
    href="javascript:void(0)"
    (click)="open(addSharedContent)"
    class="btn primary-ebtn font-weight-bold py-3 px-6 me-3"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
>
    {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
</a>
<mat-icon *ngIf="sharedContent != null">
    <a
        #tooltip="matTooltip"
        matTooltip="Edit"
        [matTooltipPosition]="tooltip_position"
        (click)="open(addSharedContent)"
        matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco }}"
    >
        edit
    </a>
</mat-icon>
<ng-template #addSharedContent let-modal>
    <div class="modal-header">
        <h4 *ngIf="sharedContent == null">{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }} {{ headerName }}</h4>
        <h4 *ngIf="sharedContent != null">{{ 'SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco }} {{ headerName }}</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="btnCancelClicked()">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable">
        <div class="row hero-image-card">
            <div class="col-md-12">
                <div class="card card-custom gutter-b card-stretch">
                    <div class="card-body">
                        <div class="row m-0">
                            <div class="col-md-4">
                                <div class="card-body" style="padding: 8px">
                                    <label class="hoverable" for="fileInput">
                                        <mat-icon *ngIf="imageSrc == null">
                                            <a
                                                #tooltip="matTooltip"
                                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }} "
                                                [matTooltipPosition]="tooltip_position"
                                                >add</a
                                            >
                                        </mat-icon>
                                        <mat-icon *ngIf="imageSrc && hideEditOption == true">
                                            <a
                                                #tooltip="matTooltip"
                                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco }} "
                                                [matTooltipPosition]="tooltip_position"
                                                >edit</a
                                            >
                                        </mat-icon>
                                        <input
                                            id="fileInput"
                                            type="file"
                                            accept="image/*"
                                            (click)="selectedImage.value = null"
                                            (change)="onSelectFile($event)"
                                            style="display: none"
                                            #selectedImage
                                        />
                                    </label>
                                    <mat-icon *ngIf="imageSrc && hideDeleteOption == true">
                                        <a
                                            #tooltip="matTooltip"
                                            matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DELETE' | transloco }} "
                                            [matTooltipPosition]="tooltip_position"
                                            (click)="btnDeleteImage()"
                                            >delete</a
                                        >
                                    </mat-icon>
                                    <div *ngIf="imageSrc" class="edit_banner_img">
                                        <img mat-card-image [src]="imageSrc" alt="upload-image" style="max-height: 100px; max-width: 100px" />
                                    </div>
                                    <p>{{ 'SETTING_PAGE.IDMS_SETTINGS.ALLOWED_FILE_TYPES' | transloco }} : png, jpg, jpeg</p>
                                </div>
                            </div>

                            <div class="col-md-8" [formGroup]="srdContentForm">
                                <div class="card-body" style="position: relative; padding: 8px">
                                    <div *ngIf="generalTabIndex == 1" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TYPE' | transloco }} :</mat-label>
                                        <mat-select
                                            formControlName="sharedContentType"
                                            name="type"
                                            class="lubricant-select"
                                            class="dropdown-wrapper"
                                            panelClass="dropdown-wrapper"
                                        >
                                            <mat-option class="option-list" *ngFor="let sct of sharedContentTypeList" [value]="sct.sharedContentTypeId">{{
                                                sct.value
                                            }}</mat-option>
                                        </mat-select>
                                    </div>

                                    <div *ngIf="generalTabIndex == 1 || generalTabIndex == 2" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TITTLE' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="title"
                                                formControlName="heading"
                                                name="title"
                                                (keypress)="onKeyPress($event)"
                                                (paste)="onKeyPress($event)"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3 mt-3">
                                        <div class="d-flex" formGroupName="checkBoxGroup">
                                            <div class="checkbox">
                                                <mat-checkbox class="checkbox-wrap" formControlName="landingPageCheck">{{
                                                    'SETTING_PAGE.GENRAL_SETTINGS.LABALS.LANDING_PAGE' | transloco
                                                }}</mat-checkbox>
                                            </div>
                                            <div class="checkbox ms-5">
                                                <mat-checkbox class="checkbox-wrap" formControlName="homePageCheck">{{
                                                    'SETTING_PAGE.GENRAL_SETTINGS.LABALS.HOME_PAGE' | transloco
                                                }}</mat-checkbox>
                                            </div>
                                        </div>
                                        <span
                                            class="error-message"
                                            *ngIf="
                                                srdContentForm.get('checkBoxGroup').hasError('requireOneCheckboxToBeChecked') &&
                                                srdContentForm.get('checkBoxGroup').touched &&
                                                sharedContent == null
                                            "
                                        >
                                            {{ 'SETTING_PAGE.IDMS_SETTINGS.AT_LEAST_ONE_CHECKBOX_SHOULD_BE_CHECKED' | transloco }}
                                        </span>
                                        <span
                                            class="error-message"
                                            *ngIf="srdContentForm.get('checkBoxGroup').hasError('requireOneCheckboxToBeChecked') && sharedContent != null"
                                        >
                                            {{ 'SETTING_PAGE.IDMS_SETTINGS.AT_LEAST_ONE_CHECKBOX_SHOULD_BE_CHECKED' | transloco }}
                                        </span>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.HEADING' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="Heading"
                                                formControlName="heading"
                                                name="heading"
                                                (keypress)="onKeyPress($event)"
                                                (paste)="onKeyPress($event)"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.SUB_HEADING' | transloco }}:</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="Sub Heading"
                                                formControlName="subHeading"
                                                name="sub_heading"
                                                (keypress)="onKeyPress($event)"
                                                (paste)="onKeyPress($event)"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 2" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DESCRIPTION' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="Discription"
                                                formControlName="subHeading"
                                                name="sub_heading"
                                                (keypress)="onKeyPress($event)"
                                                (paste)="onKeyPress($event)"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div class="p_button" *ngIf="generalTabIndex == 2" class="mb-3 mt-3">
                                        <div style="width: 100%; margin-bottom: 20px; display: table">
                                            <div class="btn-group custom-toggle-wrap" role="group">
                                                <label
                                                    *ngFor="let opt of stateOptions"
                                                    class="btn custom-toggle"
                                                    [class.active]="opt.value === srdContentForm.get('method')?.value"
                                                >
                                                    <input type="radio" class="btn-check" [value]="opt.value" formControlName="method" autocomplete="off" />
                                                    {{ opt.label }}
                                                </label>
                                            </div>
                                        </div>
                                        <div *ngIf="method == 'Purchase'">
                                            <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.PRICE' | transloco }} :</mat-label>
                                            <mat-form-field class="example-full-width custom-text-field">
                                                <input
                                                    type="text"
                                                    matInput
                                                    placeholder="Price"
                                                    formControlName="price"
                                                    name="price"
                                                    (keypress)="fromControlsValidationHandler($event, 1)"
                                                    (paste)="fromControlsValidationHandler($event, 2)"
                                                />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_TEXT' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="Navigation Text"
                                                formControlName="navigationText"
                                                name="navigation_text"
                                                (keypress)="onKeyPress($event)"
                                                (paste)="onKeyPress($event)"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_LINK' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input type="text" matInput placeholder="Navigation Link" formControlName="navigationLink" name="navigation_link" />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 1" style="width: 100%" class="mb-3 mt-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DATE' | transloco }}:</mat-label>

                                        <dx-date-box
                                            class="dx-date-custom-wrapper"
                                            formControlName="date"
                                            displayFormat="dd-MMM-yyyy"
                                            [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                            blockDateTyping
                                        >
                                        </dx-date-box>
                                        <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            *ngIf="sharedContent != null && hideEditOption == true"
            type="button"
            class="btn primary-ebtn"
            [disabled]="!(this.srdContentForm.valid && this.srdContentForm.dirty)"
            (click)="btnUpdateClicked()"
        >
            {{ 'SETTING_PAGE.IDMS_SETTINGS.UPDATE' | transloco }}
        </button>
        <button *ngIf="sharedContent == null" type="button" class="btn primary-ebtn" [disabled]="!this.srdContentForm.valid" (click)="btnAddClicked()">
            {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
        </button>
        <!-- <button type="button" class="btn secondary-ebtn" (click)="consoleForm()">form</button> -->
        <button type="button" class="btn secondary-ebtn" (click)="btnCancelClicked()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
    </div>
</ng-template>
<!-- </form> -->
